import { StateService } from '@infra/state/state.service';
import { inject, Injectable } from '@angular/core';
import { type Resolve } from '@angular/router';
import { CompanyService } from '@api/services/company.service';
import { SignalRService } from '@infra/services/signal-r.service';
import { AuthService } from '@infra/auth/auth.service';
import { Globals } from '@system/globals';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class CompanyResolver implements Resolve<boolean> {
  private readonly authService = inject(AuthService);
  private readonly companyService = inject(CompanyService);
  private readonly stateService = inject(StateService);
  private readonly signalRService = inject(SignalRService);

  resolve(): Observable<boolean> {
    return this.companyService.get(this.authService.companyId).pipe(
      map(company => {
        if (company.modules.some(x => x === Globals.PRODUCT_MODULE_ESSENTIALS) && company.isActive) {
          this.stateService.showSearch(true);
          this.stateService.setCompany(company);

          this.signalRService.startConnection(company.id, null).then();
        } else {
          this.authService.logout();
        }
        return true;
      })
    );
  }
}
